<div class="container-group" *ngIf="data">
  <div *ngIf="data.bookingId">
    <span class="titol">{{ getResourceBooking() | translate }}</span>
    <span class="valor">{{data.bookingId}}</span>
    <span class="titol">{{ 'PACKAGELABELCOMPONENT.LABEL_CREATION_DATE_TIME.CAPTION' | translate }}</span>
    <span class="valor">
      <datehour-viewer [value]="data.labelCreationDateTime" [showOriginal]="false" [showTimeZone]="false">
      </datehour-viewer>
    </span>
    <button class="action slim" *ngIf="data.hasLabel"
      (click)="getLabel()">{{ 'PACKAGELABELCOMPONENT.GETLABEL.CAPTION' | translate}}</button>
  </div>
  <div *ngIf="!data.bookingId">
    <span class="valor">{{ getResourceNoLabel() | translate }}</span>
    <button class="action slim"
      (click)="askingCreateLabel = true">{{ 'PACKAGELABELCOMPONENT.CREATELABEL.CAPTION' | translate}}</button>
    <confirmation-dialog [expanded]="askingCreateLabel" helptitleresource="PACKAGELABELCOMPONENT.CREATELABEL.CAPTION"
      helpresource="{{ getResourceCreateLabelConfirm() }}" (onConfirm)="createLabel()"
      (onCancel)="askingCreateLabel = false"></confirmation-dialog>
  </div>
</div>